var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_4434",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 33
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 1H31.5V32H0.5V1Z",
    fill: "white",
    stroke: "#000000"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_4434)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.95423 8.04692H6.41737C3.67318 8.04692 1.42505 10.2933 1.42505 13.0394V13.8543C1.42505 16.4107 3.37206 18.5331 5.85574 18.8149",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.248 10.7443C9.01142 12.5195 8.42505 14.7429 8.42505 16.8883",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.22201 28.9821C0.89425 28.9821 0.625 28.7146 0.625 28.385V26.4574C0.625 26.1298 0.892501 25.8622 1.22201 25.8622H30.7683C31.096 25.8622 31.3652 26.1298 31.3652 26.4574V28.385C31.3652 28.7126 31.096 28.9821 30.7683 28.9821H1.22201Z",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2365 8.04922H21.9108V6.41761C21.9108 5.51935 21.1756 4.7841 20.2791 4.7841H10.5816C9.68338 4.7841 8.94995 5.51935 8.94995 6.41761V8.04922H12.6242",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3763 4.78516V3.06492C17.3763 1.99841 16.5046 1.12679 15.4381 1.12679C14.3716 1.12679 13.5 1.99841 13.5 3.06492V4.78516",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0761 25.8648C18.7729 24.0773 17.7225 22.3128 18.3107 18.851H23.0531H27.7956C28.3838 22.3128 27.3332 24.0773 25.0302 25.8648",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.799 18.8498H29.0445C30.2102 18.8498 31.1667 19.8046 31.1667 20.9722C31.1667 22.1395 30.2102 23.0946 29.0445 23.0946H27.4501",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.875 28.9837V31.875H29.343V28.9837",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.1162 28.9837V31.875H2.65002V28.9837",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.37536 25.8648C8.42674 25.8082 8.47637 25.7498 8.52418 25.6859C9.30192 24.6779 9.91487 22.5518 9.44893 21.2054C8.02637 21.0957 6.12723 22.2294 5.34949 23.2394C4.64975 24.1464 4.74187 25.204 5.09443 25.8648",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.69229 22.0648C6.07222 20.5005 5.72498 18.7448 5.72498 16.8882C5.72498 13.3768 6.97042 10.2215 8.95104 8.04778M21.9102 8.04778C23.8924 10.2215 25.1379 13.3768 25.1379 16.8882C25.1379 17.556 25.0935 18.2115 25.0068 18.8493",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.74558 22.8088C4.83319 21.9354 3.26007 21.1115 2.03769 21.2056C1.56995 22.552 2.18294 24.6779 2.96063 25.6859C3.01025 25.7498 3.05988 25.8082 3.11126 25.8648",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4286 8.04922H15.425",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0965 15.6727L29.265 9.72534H23.1797",
    stroke: "#000000",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTea);
export default __webpack_public_path__ + "static/media/tea.70f1e9d2ee91edf88ff37581483077af.svg";
export { ForwardRef as ReactComponent };